import { render, staticRenderFns } from "./BranchOverView.vue?vue&type=template&id=12256cab&scoped=true&"
import script from "./BranchOverView.vue?vue&type=script&lang=js&"
export * from "./BranchOverView.vue?vue&type=script&lang=js&"
import style0 from "./BranchOverView.vue?vue&type=style&index=0&id=12256cab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12256cab",
  null
  
)

export default component.exports